<div #lavContainer 
                    [ngStyle]="{'width': viewWidth, 'height': viewHeight, 'overflow':'hidden', 'margin': '0 auto'}">    
               </div>


// WEBPACK FOOTER //
// ./node_modules/ng-lottie/dist/esm/src/lottieAnimationView.component.d.ts.LottieAnimationViewComponent.html